const getSubscriptionDeliveryIntervals = (serverLineItem, subscriptionIntervalsFallback, isAvailableForSubscription, isSubscription) => {
  const { variant } = serverLineItem;
  if (!isAvailableForSubscription || isSubscription) {
    return void 0;
  }
  const subscriptionIntervalsProductData = "variantTypeDetails" in variant ? variant.variantTypeDetails.subscriptionIntervals : void 0;
  const subscriptionIntervals = subscriptionIntervalsProductData?.length ? subscriptionIntervalsProductData : subscriptionIntervalsFallback;
  if (subscriptionIntervals?.length === 0 || !subscriptionIntervals) {
    console.error(
      `Product is available for subscription but has no valid delivery intervals or fallback configured. sku: ${variant.sku}`
    );
    return void 0;
  }
  return subscriptionIntervals;
};
export {
  getSubscriptionDeliveryIntervals
};
//# sourceMappingURL=get-subscription-delivery-intervals.js.map
